<!-- eslint-disable custom/no-direct-vuetify-components -->
<template>
  <v-btn class="big-primary-button" :ripple="false" @click="emit('click')">
    <slot />
  </v-btn>
</template>

<script lang="ts" setup>
const props = withDefaults(
  defineProps<{
    color?: string
    colorHover?: string
  }>(),
  {
    color: 'primary',
    colorHover: 'blue',
  }
)

const emit = defineEmits<{
  click: []
}>()

const { getColorValue } = useColor()
const colorValue = computed(() => {
  return getColorValue(props.color)
})
const hoverColorValue = computed(() => {
  return getColorValue(props.colorHover)
})
</script>

<style lang="scss">
.big-primary-button {
  box-shadow: 0 16px 29px 1px rgba(40, 62, 102, 0.03);
  border: 2px solid transparent !important;
  border-radius: 3 * $bw;
  background-color: v-bind(colorValue);
  &:hover {
    box-shadow: none;
    background-color: v-bind(hoverColorValue);
  }
  &.v-btn:not(.v-btn--round).v-btn--size-default {
    height: 72px;
    @include max-width(sm) {
      height: 56px;
    }
  }
  .v-btn__overlay {
    background-color: v-bind(colorValue);
    &:hover {
      box-shadow: none;
      background-color: v-bind(hoverColorValue);
    }
  }
  .v-btn__content {
    font-size: 1.25rem;
    color: $c-white;
    font-weight: 800;
    width: 100%;
  }
}
</style>
